// el.call('fetchAiProviderDiagnostics') — live per-provider model
// diagnostics for the AI model picker (GET /core/ai/providers via
// sdk.ai.describeProviders(), backed by
// ModelRouterService.describeConfiguredProviders()/listDemotedProviders()).
//
// MOVED HERE from packages/preview/functions/_simone/previewAiTransport.js
// (tickets/sonnet.md "live AI model diagnostics are DEAD on the workspace
// shell"): the function was registered ONLY in the preview package's
// function slice, but its three el.call sites live in SHARED components
// (AiModelSwitcher ×2, AiSettingsPanel) that every host app renders — on
// the workspace shell (which does not load preview) the call resolved to
// nothing and was swallowed by the surrounding try/catch: no error, no
// diagnostics, silent. The function's only dependency (getAiService) was
// already a shared function, so SHARED is its correct home — every app
// that loads shared (shell, preview, marketplace, …) now resolves it.
// preview re-exports a delegate for back-compat.
//
// Root key `aiProviderDiagnostics` is intentionally NOT chat-scoped (ck) —
// it is server-wide config, identical for every chat surface/scope in the
// session. Declared in workspace/state-app.js so the write survives (the
// undeclared-key drop was fault 2 of the same ticket).
import { getAiService } from './aiService.js'

export const fetchAiProviderDiagnostics = function () {
  const root = this.state && this.state.root
  if (!root || !root.update) return
  const ai = getAiService()
  if (!ai || typeof ai.describeProviders !== 'function') return
  Promise.resolve(ai.describeProviders())
    .then((diagnostics) => {
      if (root.update) root.update({ aiProviderDiagnostics: diagnostics })
    })
    .catch((err) => {
      console.warn('[shared] fetchAiProviderDiagnostics:', err)
    })
}
